import React, { useState } from 'react';
import CloseButton from '../Reutilizaveis/CloseButton';
import { ButtonPrimary } from '../StyledComponent';
import { ContainerNeedHelp } from './styles';
import { ReactComponent as PhoneIcon } from '../../assets/novosicones/call.svg';
import { useHistory } from 'react-router-dom';

const NeedHelp = ({ tema }) => {
  const [isShowNeedHelpInfos, setIsSHowNeedHelpInfos] = useState(false);

  const history = useHistory();

  function handleClickContactUs() {
    history.push('/precisa-de-ajuda');
  }

  function toggleShowNeedHelpInfos() {
    setIsSHowNeedHelpInfos(!isShowNeedHelpInfos);
  }

  return (
    <ContainerNeedHelp tema={tema}>
      <span className='toggle-text' onClick={toggleShowNeedHelpInfos}>
        Precisa de ajuda?
      </span>

      {isShowNeedHelpInfos && (
        <div className='container-need-help'>
          <div className='header-need-help'>
            <span>Central de relacionamento</span>
            <CloseButton
              color={'#fff'}
              borderColor={'#fff'}
              tamanho={28}
              marginRight={0}
              onClick={toggleShowNeedHelpInfos}
            />
          </div>
          <div className='body-need-help'>
            <div className='contact-container'>
              <span> De segunda a sexta-feira, das 9 h às 17h </span>
              <span className='phone'>
                <PhoneIcon fill={tema?.primaryColor} /> (31) 4002-2600
              </span>
            </div>
            <ButtonPrimary tema={tema} onClick={handleClickContactUs}>
              CLIQUE AQUI E FALE CONOSCO
            </ButtonPrimary>
          </div>
        </div>
      )}
    </ContainerNeedHelp>
  );
};

export default NeedHelp;
